import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("下载")

import { get_download_invoice_file_result_page } from '@/api/erp-invoice';
  import { useTable } from '@/components/WeTable';
  import { useAppInfo } from '@/hooks/useAppInfo';
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { apiRoot } = useAppInfo();
  const [register] = useTable({
    title: '发票下载结果页',
    api: (params: any) => {
      return get_download_invoice_file_result_page(params);
    },
    columns: [
      {
        title: '文件名',
        dataIndex: 'rd_file_name',
      },
      {
        title: '生成结果',
        dataIndex: 'rd_zip_type',
        componentType: 'a-select',
      },
      {
        title: '失败原因',
        dataIndex: 'fail_reason',
        hiddenFilter: true,
      },
      {
        title: '操作人',
        dataIndex: 'creator_name',
        componentType: 'a-select',
      },
      {
        title: '操作时间',
        dataIndex: 'create_time',
      },
      {
        title: '操作',
        dataIndex: 'action',
        flag: 'ACTION',
        slots: {
          customRender: 'action',
        },
      },
    ],
  });
  const openFile = (file_code) => {
    window.open(`${apiRoot.value}/inner_file/${file_code}`);
  };

return (_ctx: any,_cache: any) => {
  const _component_AButton = _resolveComponent("AButton")!
  const _component_WeTable = _resolveComponent("WeTable")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_WeTable, { onRegister: _unref(register) }, {
        action: _withCtx(({ record }) => [
          (record.inner_file_id)
            ? (_openBlock(), _createBlock(_component_AButton, {
                key: 0,
                type: "link",
                onClick: ($event: any) => (openFile(record.rd_file_code))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onRegister"])
    ]),
    _: 1
  }))
}
}

})